<total-item
    class="total-item"
    *ngFor="let totalItem of totalItems || emptyTotals"
    [negative]="totalItem.negative"
    [percent]="totalItem.percent"
    [title]="totalItem.title"
    [value]="totalItem.value"
    [subTitles]="totalItem.subTitles"
    [complex]="totalItem.complex"
    [relatedDate]="relatedDate"
></total-item>
